<template>
  <v-dialog width="555" v-bind="{ ...$props, ...$attrs }" scrim @update:model-value="$emit('update:model-value', $event)">
    <v-card max-width="555" variant="flat">
      <v-card-title>Remove Full Access to Demographic Survey Report</v-card-title>
      <v-card-text>
        <p>
          This will remove the ability for <strong>{{ userToRemove?.name || 'this user' }}</strong> to access the
          <a
            href="/app/insights/demographic-survey-report?tab=survey"
            target="_blank"
            rel="noopener noreferrer"
          >
            Survey Insights
          </a>
          tab in the Demographic Survey Report.
        </p>
        <br>
        <p>Access to the Distribution Insights tab will remain.</p>
        <br>
        <p>They will not be notified of this change. </p>
        <br>
        <p>Are you sure you want to continue?</p>
      </v-card-text>
      <v-card-actions>
        <DpplNewButton color="error" variant="flat" :loading="removingUser" @click="handleRemoveUserAccess">
          Remove Full Report Access
        </DpplNewButton>
        <DpplNewButton color="textDarkest" variant="outlined" @click="$emit('update:model-value', false)">
          Cancel
        </DpplNewButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';
import { ref } from 'vue';
import { useAppSnackbar } from '@/stores/app/snackbar';
import { removeAccessToDemographicSurveyReport } from '@/api/settings';

const props = defineProps({
  userToRemove: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['update:model-value', 'removed-user']);

const removingUser = ref(false);

const { addErrorSnackbar } = useAppSnackbar();

const handleRemoveUserAccess = async () => {
  removingUser.value = true;

  try {
    const userId = props.userToRemove.id;

    await removeAccessToDemographicSurveyReport(userId);

    emit('removed-user', userId);
  } catch (error) {
    addErrorSnackbar({
      text: 'There was an error removing access for the user.',
    });
    throw error;
  } finally {
    removingUser.value = false;
    emit('update:model-value', false);
  }
};
</script>

<style scoped lang="less">
:deep(.v-card) {
  background: @white;
  border-radius: 8px !important;
  padding: 0 !important;
}

:deep(.v-card-title) {
  padding: 16px;
  text-align: left;
  font-size: 15px;
  font-weight: 500;
  line-height: 150%;
  border-bottom: 1px solid @stroke-default;
}

:deep(.v-card-text) {
  padding: 16px;

  p {
    font-size: 13px;
    font-weight: 500;
    line-height: 150%;
    color: @text-darkest;
  }

  a {
    color: @text-brand;
    cursor: pointer;
    font-weight: 700;
  }

  strong {
    font-weight: 700;
  }
}

:deep(.v-card-actions) {
  padding: 16px;
}
</style>
